import React from 'react';
import { Check, X } from 'lucide-react';
import { getPasswordRequirements } from '../utils/passwordValidation';

/**
 * PasswordRequirements component displays a list of password requirements
 * with visual indicators for which requirements are met
 * 
 * @param {Object} props Component props
 * @param {string} props.role User role to determine which requirements to display
 * @param {Object} props.validationState Validation state with requirement status
 */
const PasswordRequirements = ({ role, validationState }) => {
  const requirements = getPasswordRequirements(role);
  
  return (
    <div className="mt-2 p-3 bg-slate-700/50 rounded-md border border-slate-600">
      <h4 className="text-sm font-medium text-slate-300 mb-2">
        Password Requirements:
      </h4>
      <ul className="space-y-1.5">
        {requirements.map((req) => (
          <li 
            key={req.id} 
            className="flex items-start text-xs"
          >
            <span className="mr-2 mt-0.5">
              {validationState?.requirements?.[req.id] ? (
                <Check className="h-3.5 w-3.5 text-green-400" />
              ) : (
                <X className="h-3.5 w-3.5 text-red-400" />
              )}
            </span>
            <span className={
              validationState?.requirements?.[req.id] 
                ? "text-slate-300" 
                : "text-slate-400"
            }>
              {req.text}
              {req.required && <span className="text-red-400 ml-1">*</span>}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordRequirements;